import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-about',
  templateUrl: './portfolio-about.component.html',
  styleUrls: ['./portfolio-about.component.scss']
})
export class PortfolioAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
